export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Commandes",
      layout: "dashboard",
    },
    path: "/orders",
    name: "orders",
    component: () => import("@/layouts/index/OrderIndex.vue"),
    children: [
      // Commandes clients
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste des commandes clients",
          layout: "dashboard",
        },
        path: "index",
        name: "orders-index",
        component: () => import("@/views/orders/customers/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer une commande client",
          layout: "dashboard",
        },
        path: "create",
        name: "orders-create",
        component: () => import("@/views/orders/customers/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails de la commande client",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "orders-details",
        component: () => import("@/views/orders/customers/Details.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails de la commande client",
          layout: "dashboard",
        },
        path: ":reference/to-sale",
        name: "orders-to-sale",
        component: () => import("@/views/orders/customers/ToSale.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier la commande client",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "orders-edit",
        component: () => import("@/views/orders/customers/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Marquer la commande client comme livrée",
          layout: "dashboard",
        },
        path: ":reference/delivered",
        name: "orders-delivered",
        component: () => import("@/views/orders/customers/Delivered.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Ajouter des articles à une commande client",
          layout: "dashboard",
        },
        path: "items/create",
        name: "orders-items-create",
        component: () => import("@/views/orders/customers/items/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier les articles d'une commande client",
          layout: "dashboard",
        },
        path: ":reference/items/edit",
        name: "orders-items-edit",
        component: () => import("@/views/orders/customers/items/Edit.vue"),
      },

      // Commandes fournisseurs
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste des commandes fournisseurs",
          layout: "dashboard",
        },
        path: "suppliers/index",
        name: "orders-suppliers-index",
        component: () => import("@/views/orders/suppliers/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer une commande fournisseur",
          layout: "dashboard",
        },
        path: "suppliers/create",
        name: "orders-suppliers-create",
        component: () => import("@/views/orders/suppliers/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails de la commande fournisseur",
          layout: "dashboard",
        },
        path: "suppliers/:reference/details",
        name: "orders-suppliers-details",
        component: () => import("@/views/orders/suppliers/Details.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier la commande fournisseur",
          layout: "dashboard",
        },
        path: "suppliers/:reference/edit",
        name: "orders-suppliers-edit",
        component: () => import("@/views/orders/suppliers/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Ajouter les articles d'une commande fournisseur",
          layout: "dashboard",
        },
        path: "suppliers/items/create",
        name: "orders-suppliers-items-create",
        component: () => import("@/views/orders/suppliers/items/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier les articles d'une commande fournisseur",
          layout: "dashboard",
        },
        path: "suppliers/:reference/items/edit",
        name: "orders-suppliers-items-edit",
        component: () => import("@/views/orders/suppliers/items/Edit.vue"),
      },

    ],
  },
];
